<script>
export default {
  props: ['formdata'],
  data() {
    return {
      localModel: {},
      initial:true,
    }
  },
  methods: {
    previousStep() {
      this.emitter.emit("step", 2);
    },
    nextStep() {
      this.initial = false
      if (this.validate()) {
        this.emitter.emit("modelUpdated", this.localModel);
        this.emitter.emit("step", 4);
      }

    },
    validate() {
      if (this.localModel.lookingfor === "" ||
          this.localModel.aantal_personen === "" ||
          this.localModel.movable === ""
      )
        return false;
      return true;
    },

  },
  mounted() {
    this.localModel = this.formdata;
  }
}
</script>

<template>

  <!------------ step form Area Start  ----------->
  <section class="step-form">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="step-form-wrapper">
            <div class="contact-form">
              <form action="">
                <div class="step-form-content">
                  <form action="data.php" method="post" class="form">
                    <!-- Progress Bar -->
                    <div class="progress-bar">
                      <div class="progress" id="progress"></div>
                      <div class="progress-step active" data-title="Personal"></div>
                      <div class="progress-step active" data-title="Contact "></div>
                      <div class="progress-step active" data-title="Experiences"></div>
                      <div class="progress-step" data-title="Links"></div>
                      <div class="progress-step" data-title="Links"></div>
                    </div>

                    <!-- Steps -->
                    <div class="form-step active">
                      <h3>Ik ben op zoek naar*</h3>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-card-select">
                                <h4>Doel van de ruimte</h4>
                                <select class="form-select" v-model="localModel.lookingfor"
                                        :style="localModel.lookingfor === '' && initial === false  ? 'border:1px solid red' : ''"
                                        aria-label="Default select example">
                                  <option selected value="schaftwagens">Schaften</option>
                                  <option value="school">School</option>
                                  <option value="kantoor_werkplek">Kantoor werkplek</option>
                                  <option value="vergaderplek">Vergaderplek</option>
                                  <option value="toiletruimte">Toiletruimte</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-form-info">
                                <h4>Aantal personen*</h4>
                                <input type="text" v-model="localModel.aantal_personen"
                                       :class="localModel.aantal_personen === '' && initial === false  ? 'invalid' : ''"
                                       placeholder="Aantal personen">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-card-select">
                                <h4>Verplaatsbaar middels*</h4>
                                <select class="form-select" v-model="localModel.movable"
                                        :style="localModel.movable === '' && initial === false  ? 'border:1px solid red' : ''"
                                        aria-label="Default select example">
                                  <option selected value="auto_bus">Auto of bus</option>
                                  <option value="vrachtwagens">Vrachtwagen</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-form-info">
                                <label for="">Heeft u nog eisen of wensen?</label>
                                <textarea v-model="localModel.requirements_text" name="" id=""
                                          placeholder="Heeft u nog bepaalde eisen of wensen. Geef ze hier door."></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="contact-form-btn contact-form-btn-two">
                  <button class="contact-form-btn-gray" @click.prevent="previousStep()">Vorige</button>
                  <button @click.prevent="nextStep()">Volgende</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!------------ step form Area End ------------->


</template>

<style scoped>

</style>